module.exports = "/packs/images/navigation/juul-nora-wide-4fe6cf8f3d2be92ae95b1ddeea282067.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/navigation/juul-nora-wide.jpg
// module id = 1816
// module chunks = 0